<div class="right-margin">
  <button class="close-icon"  (click)="cancel()"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body sellerTermDialogForm form">
  <h2>@if (sellOffer.id==0) {
    <span>Add Seller Offer</span>
    }@if (sellOffer.id!=0) {
    <span>Update Seller Offer</span>
  }</h2>
  <div class="row m-0">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
      <select [class]="getClassesForInput('utilityId', true, (sellOffer.utility==null)?null:sellOffer.utility.name)" name="utilityId" [compareWith]="compareFn" [(ngModel)]="sellOffer.utility"
        (change)="resetError('utilityId'); reloadSelects();">
        @if (sellOffer==null || sellOffer.id==0) {
          <option [ngValue]="null" [selected]="true" [disabled]="true">Utility</option>
        }
        @for (utility of utilities; track utility) {
          <option [ngValue]="utility">{{utility.name}}</option>
        }
      </select>
      @if (getVisibilityForLabel((sellOffer.utility==null)?null:sellOffer.utility.name)) {
        <div class="placeholder">Utility</div>
      }
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
      <select [compareWith]="compareFn" [class]="getClassesForInput('loadZoneId', true, (sellOffer.loadZone==null)?null:sellOffer.loadZone.name)" name="loadZoneId" [(ngModel)]="sellOffer.loadZone" (change)="resetError('loadZoneId'); reloadSelects();">
        @if (sellOffer==null || sellOffer.id==0) {
          <option [ngValue]="null" [disabled]="true">Load Zone</option>
        }
        @for (loadZone of loadZones; track loadZone) {
          <option [ngValue]="loadZone">{{loadZone.name}}</option>
        }
      </select>
      @if (getVisibilityForLabel((sellOffer.loadZone==null)?null:sellOffer.loadZone.name)) {
        <div class="placeholder">Load Zone</div>
      }
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
      @if (pageLoaded()) {
      <ng-multiselect-dropdown name="rateClass" [placeholder]="'Rate Class'" [settings]="dropdownSettings" [class]="getClassesForInput('loadZoneId', true, (sellOffer.rateClasses==null||sellOffer.rateClasses.length==0)?null:sellOffer.rateClasses.length.toString())" [data]="rateClasses" [(ngModel)]="sellOffer.rateClasses" (onSelect)="onItemSelect($event, sellOffer, true)" onDeSelect="onItemSelect($event, sellOffer, false)">
        <ng-template
          #optionsTemplate
          let-item
          let-option="option"
          let-id="id"
          let-isSelected="isSelected"
          >
          <div>
            <label>{{option}}</label>
          </div>
        </ng-template>
        <ng-template #optionSelectedTemplate let-option="option" let-id="id">
          <div>{{option}}</div>
        </ng-template>

      </ng-multiselect-dropdown>
      }
      @if (getVisibilityForLabel((sellOffer.rateClasses==null||sellOffer.rateClasses.length==0)?null:sellOffer.rateClasses.length.toString())) {
        <div class="placeholder">Rate Classes</div>
      }
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
      <input
        matInput
        [matDatepicker]="picker"
        [matDatepickerFilter]="boundInactiveDatesFilter"
        [formControl]="startDate"
        (click)="picker.open()"
        [class]="getClassesForInput('startDate', true, (startDate==null || startDate.value==null)?null:startDate.value.toString())"
        placeholder="Service Start, 1st meter read on or after"
        (dateInput)="startDateChanged($event)"
        />
      <mat-datepicker #picker  startView="year" (yearSelected)="chosenYearHandler($event, startDate)" (monthSelected)="chosenMonthHandler($event, startDate, 'startDate', picker); setDesiredTerm(); setDefaultDuration(startDate.value);"></mat-datepicker>
      @if (getVisibilityForLabel((startDate==null || startDate.value==null)?null:startDate.value.toString())) {
        <div class="placeholder">Service Start, 1st meter read on or after</div>
      }
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
      <input
        matInput
        [matDatepicker]="picker1"
        [matDatepickerFilter]="boundInactiveDatesEndFilter"
        [formControl]="endDate"
        (click)="picker1.open()"
        readonly
        placeholder="Service End, 1st meter read on or after"
        [class]="getClassesForInput('endDate', true, (endDate==null || endDate.value==null)?null:endDate.value.toString())"
        />
      @if (getVisibilityForLabel((endDate==null||endDate.value==null)?null:endDate.value.toString())) {
        <div class="placeholder">Service End, 1st meter read on or after</div>
      }
      <mat-datepicker #picker1 startView="year" (yearSelected)="chosenYearHandler($event, endDate)" (monthSelected)="chosenMonthHandler($event, endDate, 'endDate', picker1); setDesiredTerm();"></mat-datepicker>
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
      <input
        type="text"
        [class]="getClassesForInput('desiredTerm', true, sellOffer.termPeriod+'')"
        name="desiredTerm"
        disabled="true"
        [(ngModel)]="desiredTerm"
        placeholder="Term"
        />
      @if (getVisibilityForLabel((desiredTerm==null)?null:desiredTerm.toString())) {
        <div class="placeholder">Term</div>
      }
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
      <input type="text" [class]="getClassesForInput('price', true, (sellOffer==null||sellOffer.price==null)?null:sellOffer.price.toString())" name="price" [(ngModel)]="sellOffer.price" (input)="resetError('price')" (focus)="focusField('price')" (focusout)="focusOutField('price')"
        [placeholder]="(focusedField()=='price')?'0.00000':((sellOffer.id>0)?'':'Price $/kWh')" [allowNegativeNumbers]="false" mask="separator.5" thousandSeparator="" />
      @if (getVisibilityForLabel((sellOffer==null||sellOffer.price==null)?null:sellOffer.price.toString())) {
        <div class="placeholder">Price $/kWh</div>
      }
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
      <input
        matInput
        [matDatepicker]="picker2"
        [matDatepickerFilter]="boundInactiveDatesValidFilter"
        [formControl]="validDate"
        (click)="picker2.open()"
        [class]="getClassesForInput('validDate', true, (validDate==null || validDate.value==null)?null:validDate.value.toString())"
        placeholder="Good Until"
        />
      <mat-datepicker #picker2></mat-datepicker>
      @if (getVisibilityForLabel((validDate==null || validDate.value==null)?null:validDate.value.toString())) {
        <div class="placeholder">Good Until</div>
      }
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <select name="sellerContract" [class]="getClassesForInput('sellerContract', true, (sellOffer==null||sellOffer.sellerContract==null)?null:sellOffer.sellerContract.id.toString())" (change)="resetError('sellerContract');" [(ngModel)]="sellOffer.sellerContract"
        [compareWith]="compareFn">
        @if (sellOffer.id==0) {
          <option [ngValue]="null" [disabled]="true">Sales Agreement</option>
        }
        @for (sellerContract of sellerContracts; track sellerContract) {
          <option [ngValue]="sellerContract">{{sellerContract.name}}</option>
        }
      </select>
      @if (getVisibilityForLabel((sellOffer==null||sellOffer.sellerContract==null)?null:sellOffer.sellerContract.id.toString())) {
        <div class="placeholder">Sales Agreement</div>
      }
    </div>
  </div>

  @if (this.errorY().showError()) {
    <div class="error-block">{{this.errorY().error}}</div>
  }
  <div class="block-buttons">
    <button type="button" (click)="sendForm()">Finish</button>
  </div>
</div>